import { languageChoices } from '@hotjar/insights-common/constants/legacy';

/**
 * Return a language name (in English) from its ISO code.
 *
 * Usage: {{ 'en' | languageName }} -> "English"
 */
angular.module('hjApp').filter('languageName', [
    function () {
        return function (code) {
            var language,
                languages = languageChoices;

            language = _.find(languages, function (lang) {
                return code === lang.value;
            });

            // If no country is found for this code, return the same code back.
            language = language ? language.label : code;

            return language;
        };
    }
]);
